import styled from 'styled-components';
import { media } from '@pik/pik-ui';

export const TableWrapper = styled.div`
  margin-bottom: 64px;
  
  @media ${media.max768} {
    display: none;
  }
 `;

export const MobileCreditRating = styled.div`
  display: none;
  
  @media ${media.max768} {
    display: block;
  }
 `;

export const MobileCreditRatingTable = styled.div`
  margin-bottom: 32px;
  border-top: 1px solid #E6E6E6;
`;

export const MobileCreditRatingRow = styled.div`
 display: flex;
 justify-content: space-between;
 padding: 24px 0;
 border-bottom: 1px solid #E6E6E6;
`;

export const MobileCreditRatingHeader = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #222222;
  ${({ bold }) => (bold ? 'font-weight: 500;' : '')}
`;

export const MobileCreditRatingTextWrapper = styled.div`
  max-width: 130px;
  text-align: right;
`;

export const MobileCreditRatingText = styled.div`
 font-size: 16px;
 line-height: 24px;
 color: #222222;
`;

export const MobileCreditRatingSubText = styled.div`
 font-size: 12px;
 line-height: 16px;
 color: #808080;
`;

export const Container = styled.div`
  padding: 15px 0 16px 0;
  
  
  &:last-child {
    border-bottom: none;
  }
`;

export const Title = styled.span`
  display: block;
  margin-bottom: 8px;
  font-family: Graphik;
  font-weight: 500;
  font-size: 20px;
  color: #333333;
`;

export const Text = styled.span`
  display: block;
  margin-bottom: 8px;
  font-family: Graphik;
  font-size: 16px;
  color: #222222;
`;

export const Desc = styled.span`
  display: block;
  font-family: Graphik;
  font-size: 12px;
  color: #808080;
`;
